import React, { createContext, useContext, useState, ReactNode } from "react";

interface SideNavContextType {
    isOpen: boolean;
    toggleSideNav: () => void;
    closeSideNav: () => void;
    openSideNav: () => void;
}

const SideNavContext = createContext<SideNavContextType | undefined>(undefined);

export const SideNavProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);

    const toggleSideNav = () => setIsOpen(!isOpen);
    const closeSideNav = () => setIsOpen(false);
    const openSideNav = () => setIsOpen(true);

    return <SideNavContext.Provider value={{ isOpen, toggleSideNav, closeSideNav, openSideNav }}>{children}</SideNavContext.Provider>;
};

export const useSideNav = () => {
    const context = useContext(SideNavContext);
    if (context === undefined) {
        throw new Error("useSideNav must be used within a SideNavProvider");
    }
    return context;
};
